import _ from 'lodash';

export const updateCloudCart = (api, orderItems) => {
  const cloudCart = _.map(orderItems, (ci) => ({
    amount: ci.amount,
    notes: ci.specialInstruction,
    businessItemId: ci.id,
    json: JSON.stringify(ci)
  }));
  api.post('cloudcart/set', cloudCart)
    .catch((error) => {
      // Do nothing
    });
};

export const clearCloudCart = (api) => {
  api.post('cloudcart/clear', null)
    .catch((error) => {
      // Do nothing
    });
};
